import type { CollaborationAnalysisCard } from "~vue/api/generated/collaboration-analysis";
import { ACTION } from "~vue/chatActions";
import type { ChatMessageLine } from "~vue/types/chat";

type Translate = (key: string) => string;

export const collaborationCard = (action: ChatMessageLine | null | undefined): CollaborationAnalysisCard | null =>
    action?.type === "action" && action.action_name === ACTION.EXPLORE_COLLABORATION ? action.action_params.card : null;

// What the card reports about how the exploration ended; ChatMessageList announces the same text.
export const collaborationStatusMessage = (card: CollaborationAnalysisCard | null, completed: boolean, t: Translate): string => {
    if (card?.status === "complete") {
        return t("chat.collaboration.completeStatus");
    }
    if (card?.status === "unavailable" || card?.status === "removed") {
        return card.takeaway ?? "";
    }
    if (completed) {
        return card?.takeaway ?? t("chat.collaboration.failedStatus");
    }
    return t("chat.collaboration.interruptedStatus");
};
